// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPushProvisionRequest
 */
export interface IPushProvisionRequest {
    /**
     * 
     * @type {number}
     * @memberof IPushProvisionRequest
     */
    wallet_id: number;
    /**
     * 
     * @type {string}
     * @memberof IPushProvisionRequest
     */
    correlation_id: string;
    /**
     * 
     * @type {string}
     * @memberof IPushProvisionRequest
     */
    passthru_from_idi_sdk: string;
}

/**
 * Check if a given object implements the IPushProvisionRequest interface.
 */
export function instanceOfIPushProvisionRequest(value: object): value is IPushProvisionRequest {
    if (!('wallet_id' in value) || value['wallet_id'] === undefined) return false;
    if (!('correlation_id' in value) || value['correlation_id'] === undefined) return false;
    if (!('passthru_from_idi_sdk' in value) || value['passthru_from_idi_sdk'] === undefined) return false;
    return true;
}

export function IPushProvisionRequestFromJSON(json: any): IPushProvisionRequest {
    return IPushProvisionRequestFromJSONTyped(json, false);
}

export function IPushProvisionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPushProvisionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'wallet_id': json['wallet_id'],
        'correlation_id': json['correlation_id'],
        'passthru_from_idi_sdk': json['passthru_from_idi_sdk'],
    };
}

export function IPushProvisionRequestToJSON(json: any): IPushProvisionRequest {
    return IPushProvisionRequestToJSONTyped(json, false);
}

export function IPushProvisionRequestToJSONTyped(value?: IPushProvisionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'wallet_id': value['wallet_id'],
        'correlation_id': value['correlation_id'],
        'passthru_from_idi_sdk': value['passthru_from_idi_sdk'],
    };
}

